import React from "react";

export default function Emandate() {
  return (
    <div>
      <p>Emandate</p>
    </div>
  );
}
